import { Link } from 'react-router-dom';
import { Button, Col, Container, Row, Spinner } from 'react-bootstrap';
import WelcomeCustomer from '../features/customer/WelcomeCustomer';
import './my-account-nav.scss';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectIsMobileRoute } from '../features/mobile/mobileSlice';
import AutoshipICon from '../app/styles/components/AutoshipICon';
import OrderObj from '../features/orders/orderObj';
import { selectOrderPlannerOrders } from '../pages/AutoshipPages/core/orderPlannerOrdersSlice';
import CustomerObj from '../features/customer/customerObj';
import { selectCustomer, selectCustomerIsLoaded } from '../features/customer/customerSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Image } from 'react-bootstrap';
import logo from '../assets/images/logo_white.png';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { faHeart } from '@fortawesome/free-regular-svg-icons';
import MightyDealsIcon from '../app/styles/components/MightyDealsIcon';
import ReferAFriendIcon from '../app/styles/components/ReferAFriendIcon';
import SupportHelpIcon from '../app/styles/components/SupportHelpIcon';
import CircularProgressBar from '../pages/Progressbar/CircularProgressBar';
import { selectCustomerDetails, selectCustomerDetailsIsLoaded, selectCustomerDetailsIsLoading } from '../features/customer/customerDetailSlice';
import MyAccountPage from '../pages/MyAccountPage';
import { selectToken } from '../features/user/userSlice';
import CookingIcon from '../app/styles/components/CookingIcon';
import AccountSettingsIcon from '../app/styles/components/AccountSettingsIcon';

export default function MobileMyAccount() {
    const token = useSelector(selectToken);
    const custLoaded = useSelector(selectCustomerIsLoaded);
    const customer = new CustomerObj(useSelector(selectCustomer));
    const AppURL = useSelector(selectIsMobileRoute);
    const orders: Array<Record<string, any>> = useSelector(selectOrderPlannerOrders);
    const customerData = useSelector(selectCustomerDetails);
    const customerLoading = useSelector(selectCustomerDetailsIsLoading);
    const customerLoaded = useSelector(selectCustomerDetailsIsLoaded);
    const [progress, setProgress] = useState(0);
    const customerDetails = customerData?.user_data;
    const QURLParams = AppURL ? `/?${AppURL}` : '/';
    const urlParams = AppURL ? `/?${AppURL}` : '';
    const AndURLParams = AppURL ? `&${AppURL}` : '';
    const autoshipOrders = orders.filter((order, index, self) => index === self.findIndex((o) => o.id === order.id));
    const plannedOrders = autoshipOrders.filter((order: any) => {
        const orderObj = new OrderObj(order);
        return orderObj.data.status === 'autoship' || order.status === 'autoship-onhold';;
    });
    const autoshipRedirect = (plannedOrders && plannedOrders.length > 0) ?
        `/autoship${QURLParams}` : `/autoship?start=true${AndURLParams}`;
    const membershipCustomer = (custLoaded && customer.hasMembership()) ? true : false;
    const membershipRedirectLink = membershipCustomer ? `/my-account/my-membership-details${urlParams}` : `/my-account/mightypoints${urlParams}`;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (customerDetails) {
            const totalFields = Object.keys(customerDetails).filter(key => !key.includes('address_two') && !key.includes('number_of_children_in_household') && !key.includes('imageUrl')).length;
            const numCompletedFields = Object.values(customerDetails).filter((val, index) => val !== "" && val !== null && !Object.keys(customerDetails)[index].includes('address_two') && !Object.keys(customerDetails)[index].includes('number_of_children_in_household') && !Object.keys(customerDetails)[index].includes('imageUrl')).length;
            const ProgressBar = Math.round((numCompletedFields / totalFields) * 100);
            setProgress(ProgressBar);
        }
    }, [customerDetails])

    if (!token) {
        return (
            <MyAccountPage />
        )
    }

    return (
        <Container fluid="lg" className='my-account-page'>
            <div className='my-account-nav my-md-5'>
                <Row>
                    <Col xs={7} className='p-0 px-2'>
                        <WelcomeCustomer />
                    </Col>
                    <Col xs={5} className='p-0 px-3 d-flex align-items-center justify-content-end'>
                        <span className="text-uppercase fw-400 myaccounttxt font-league-gothic">My Account</span>
                    </Col>
                    <Col xs={4} className='p-0'>
                        <Button
                            as={Link as any}
                            to={`/order/${urlParams}`}
                            variant="white"
                            size="lg"
                            className={`myaccountbox no-hover-effect d-flex flex-column align-items-center justify-content-center text-white`}
                        >
                            <div className='cart-icon d-flex align-items-center position-relative d-inline-block'>
                                <CookingIcon width={50} height={50} />
                            </div>
                            <span className="text-uppercase fs-15px font-glegoo">ORDER NOW</span>
                        </Button>
                    </Col>
                    <Col xs={4} className='p-0'>
                        <Button
                            as={Link as any}
                            to={`/my-account/orders${urlParams}`}
                            variant="white"
                            size="lg"
                            className={`myaccountbox no-hover-effect d-flex flex-column align-items-center justify-content-center text-white`}
                        >
                            <div className='cart-icon d-flex align-items-center position-relative d-inline-block pb-2'>
                                <Image
                                    className="mm-affiliate border-0"
                                    src={logo}
                                    thumbnail={true}
                                    loading="lazy"
                                    alt="MightyMeals Logo"
                                />
                            </div>
                            <span className="text-uppercase fs-15px font-glegoo">My Orders</span>
                        </Button>
                    </Col>
                    <Col xs={4} className='p-0'>
                        <Button
                            as={Link as any}
                            to={autoshipRedirect}
                            variant="white"
                            size="lg"
                            className={`myaccountbox no-hover-effect d-flex flex-column align-items-center justify-content-center text-white`}
                        >
                            <div className='cart-icon d-flex align-items-center position-relative d-inline-block p-3'>
                                <AutoshipICon width={35} height={35} />
                            </div>
                            <span className="text-uppercase fs-15px font-glegoo">Schedule Orders</span>
                        </Button>
                    </Col>
                    <Col xs={4} className='p-0'>
                        <Button
                            as={Link as any}
                            to={`/my-account/my-meal-plans${urlParams}`}
                            variant="white"
                            size="lg"
                            className={`myaccountbox no-hover-effect d-flex flex-column align-items-center justify-content-center text-white`}
                        >
                            <div className='cart-icon d-flex align-items-center position-relative d-inline-block pb-3'>
                                <FontAwesomeIcon
                                    role="button"
                                    icon={faHeart}
                                    color={'white'}
                                    size={'2x' as SizeProp}
                                />
                            </div>
                            <span className="text-uppercase fs-15px font-glegoo">Favorites</span>
                        </Button>
                    </Col>
                    <Col xs={4} className='p-0'>
                        <Button
                            as={Link as any}
                            to={`/my-account/refer-a-friend${urlParams}`}
                            variant="white"
                            size="lg"
                            className={`myaccountbox no-hover-effect d-flex flex-column align-items-center justify-content-center text-white`}
                        >
                            <div className='cart-icon d-flex align-items-center position-relative d-inline-block'>
                                <ReferAFriendIcon width={70} height={70} />
                            </div>
                            <span className="text-uppercase fs-15px font-glegoo">Refer A Friend</span>
                        </Button>
                    </Col>
                    <Col xs={4} className='p-0'>
                        <Button
                            as={Link as any}
                            to={`/my-account/settings${urlParams}`}
                            variant="white"
                            size="lg"
                            className={`myaccountbox no-hover-effect d-flex flex-column align-items-center justify-content-center text-white`}
                        >
                            <div className='cart-icon d-flex align-items-center position-relative d-inline-block p-2'>
                                <AccountSettingsIcon width={60} height={50} />
                            </div>
                            <span className="text-uppercase fs-15px font-glegoo">Account Settings</span>
                        </Button>
                    </Col>
                    <Col xs={4} className='p-0'>
                        <Button
                            as={Link as any}
                            to={membershipRedirectLink}
                            state={{ isAccountPage: true }}
                            variant="white"
                            size="lg"
                            className={`myaccountbox no-hover-effect d-flex flex-column align-items-center justify-content-center text-white`}
                        >
                            {membershipCustomer ?
                                <>
                                    <span className="text-uppercase fs-13px font-glegoo">
                                        Membership Customer
                                    </span>
                                    <div className={`fs-13px text-center font-barlow`}>
                                        {customer?.data?.memberships[0]?.plan_name} Plan
                                    </div>
                                </> :
                                <>
                                    <div className={`text-large fw-500 text-center font-glegoo p-2`}>
                                        {customer.getMightyPoints()}
                                    </div>
                                    <span className="text-uppercase fs-15px font-glegoo">Mighty points</span>
                                </>}
                        </Button>
                    </Col>
                    <Col xs={4} className='p-0'>
                        <Button
                            as={Link as any}
                            to={`/mightydeals${urlParams}`}
                            variant="white"
                            size="lg"
                            className={`myaccountbox no-hover-effect d-flex flex-column align-items-center justify-content-center text-white`}
                        >
                            <div className="d-flex justify-content-center mb-2 svg-icon mightydealsIcon">
                                <MightyDealsIcon width={50} height={50} />
                            </div>
                            <span className="text-uppercase fs-15px font-glegoo">Mighty Deals</span>
                        </Button>
                    </Col>
                    <Col xs={4} className='p-0'>
                        <Button
                            as={Link as any}
                            to={`/my-account/support-help${urlParams}`}
                            variant="white"
                            size="lg"
                            className={`myaccountbox no-hover-effect d-flex flex-column align-items-center justify-content-center text-white`}
                        >
                            <div className='cart-icon d-flex align-items-center position-relative d-inline-block p-1'>
                                <SupportHelpIcon width={60} height={50} />
                            </div>
                            <span className="text-uppercase fs-15px font-glegoo">Support &amp; Help</span>
                        </Button>
                    </Col>
                    <Col xs={8} className="p-0 pt-1 px-1">
                        <div className={`${(!customerLoading && customerLoaded && customerData) ? progress === 100 ? 'bg-success' : 'bg-warning' : 'bg-warning'} d-flex align-items-center justify-content-between circularround px-4 py-3`} style={{ minHeight: '130px' }}>
                            <div className="flex-shrink-0 me-3">
                                <CircularProgressBar progress={progress} />
                            </div>
                            <div className="d-flex flex-column justify-content-center text-black text-uppercase">
                                {(!customerLoading && customerLoaded && customerData) ? (
                                    progress === 100 ? (
                                        <>
                                            <div className="mt-2">
                                                <span className="fw-700 fs-13px">Use Code <b className="text-decoration-underline">1FREEMVP</b> To Get Your Free Meal.</span>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="mt-2">
                                                <span className="fw-500 circularprogresstext text-uppercase font-barlow">get 1&nbsp;</span>
                                                <span className="fw-500 circularprogresstext text-uppercase font-barlow">free mightymeal</span>
                                            </div>
                                            <Button
                                                as={Link as any}
                                                to={`/my-account/edit-account${urlParams}`}
                                                state={{ isAccountPage: true }}
                                                variant="white"
                                                className={`w-maxcont bg-black text-white mt-1 rounded`}
                                            >
                                                COMPLETE SURVEY
                                            </Button>
                                        </>
                                    )
                                ) : (
                                    <div className="text-center my-5 h-100">
                                        <Spinner className="text-center text-dark" variant="primary" animation="grow" />
                                    </div>
                                )}
                            </div>
                        </div>
                    </Col>
                    <Col xs={4} className='p-0'>
                        <Button
                            as={Link as any}
                            to={`/my-account/surveys${urlParams}`}
                            variant="white"
                            size="lg"
                            className={`surveybox no-hover-effect d-flex flex-column align-items-center justify-content-center text-white`}
                        >
                            FEEDBACK SURVEYS
                        </Button>
                    </Col>
                </Row>
            </div>
        </Container>
    )
}